import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ILayer } from '@obvious.tech/constellation'

export const Layer = defineEntity('Layer', {
  endpoint: 'geolocation/api/Layer',
  schema: SNoop<ILayer>(),
})
